import Main from './Main.vue'
import Lista from './components/ListaRetirada'
import Retiradas from './components/Retirada'
import Cobranca from './components/Cobranca'
import AddPreretirada from './components/addPreretirada'
import Externa from './components/CobrancaExterna'

export default [{
  path: 'preretirada',
  name: 'preretirada',
  component: Main,
  children: [
 {path: '/', component: Lista, name: 'pre-retirada'},
 {path: ':id', component: Retiradas, name: 'pre-retirada.visualizar'},
 {path: 'cobranca', component: Cobranca, name: 'cobranca.visualizar'},
 {path: 'adicionar/:id', component: AddPreretirada, name: 'preretirada.adicionar'},
 {path: 'cobranca-externa', component: Externa, name: 'externa.visualizar'}
  ]
}
]



// WEBPACK FOOTER //
// ./src/app/website/preretirada/routes.js